module.exports = __webpack_public_path__ + "img/micro-unmuted.22ad3b6a.svg";